(function () {
    'use strict';

    angular
        .module('app.widgets')
        .directive('obtProfileCard', obtProfileCard);


    function obtProfileCard () {
        var directive = {
            restrict: 'E',
            templateUrl: getTemplateURL,
            scope : {
                profile:'=',
                location : '=?',
                calendarFilters : '=?'
            },
            bindToController:true,
            controller: obtProfileCardCtrl,
            controllerAs:'vmProfile'
        };
        return directive;
    }
    function getTemplateURL (elem, attr){
        return attr.profileTemplate ? attr.profileTemplate : 'app/widgets/profileCard/obt-ProfileCard.html';
    }

    obtProfileCardCtrl.$inject=['dataservice'];
    /*@NgInject*/
    function obtProfileCardCtrl(dataservice){
        var vm = this;
        vm.showBookNowButton = showBookNowButton;
        vm.cId = vm.profile.cId || vm.id;
        vm.tId = vm.profile.tId;
        vm.addCIdTId = addCIdTId;
        vm.calendar = {profile : {viewHeight: 200, hideToday:true, hideTitle:true,
            viewBasic: true, viewTreeDay:false, viewWeek: false,
            hideEventTitle:true,
            viewDay: false, viewMonth: false, defaultView:'basicThreeDays'}
            , getData : getCalendarData};

        function addCIdTId(data){
            if(data){
                data.cId = vm.cId;
                data.tId = vm.tId;
            }
            return data;
        }
        function getCalendarData(start, end){
            var filters = angular.extend({}, vm.calendarFilters,{lId:vm.profile.lId});
            return dataservice.calendar.getData(start,end, vm.cId, vm.tId,filters)
                .then(function (data) {
                    return {data: data,timezone: null};
                });
        }
        function showBookNowButton(){
            return vm.profile && vm.profile.cType && vm.profile.cId;
        }
    }
    //function link(scope, element, attrs) {}
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-ProfileCard.directive.js
 ** module id = 178
 ** module chunks = 0
 **/